import { useLocation, useNavigate } from "react-router";
import * as Tabs from "./Tabs";
import { Fragment, useEffect, useState } from "react";
import { CustomTabs } from "components";

function Reports() {
  const [activeKey, setActiveKey] = useState("1");
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const tab = searchParams.get("tab");

  useEffect(() => {
    setActiveKey(tab || "1");
  }, []);

  const handleTabChange = (key) => {
    setActiveKey(key);
    searchParams.set("tab", key);
    navigate({ search: searchParams.toString() }, { replace: true });
  };

  const tabs = [
    {
      key: "1",
      label: "Customer Reports",
      content: <Tabs.CustomerReports />,
    },
    {
      key: "2",
      label: "Revenue Reports",
      content: <Tabs.RevenueReports />,
    },
  ];

  return (
    <Fragment>
      <div className="w-full h-full">
        <div className="relative -z-1 min-h-[750px] w-[100%] lg:w-[98%] h-full ml-auto shadow-[0_4px_10px_rgba(0,0,0,0.1)] dark:shadow-[0_0px_3px_rgba(255,255,255,0.5)] flex flex-col mb-16 md:rounded-bl-md overflow-auto">
          <div className="bg-secondary w-full px-6 py-4 flex flex-col gap-1 tabs-start">
            <p className="text-white text-2xl font-bold">Reports</p>
          </div>
          <CustomTabs
            tabs={tabs.map((item) => ({
              ...item,
              label: <div id={`step${item.key}`}>{item.label}</div>,
            }))}
            activeKey={activeKey}
            onChange={handleTabChange}
          />
        </div>
      </div>
    </Fragment>
  );
}

export default Reports;
